import {SettingsContext} from 'context/SettingsProvider';
import {getDateFormater} from 'helpers/dateUtils';
import {useContext} from 'react';
import {nb, enUS} from 'date-fns/locale';

const useLanguage = () => {
  const settingsContext = useContext(SettingsContext);
  const language = settingsContext?.language;

  const dateFormatter = getDateFormater(language);

  const datefnsLocale = language === 'no' ? nb : enUS;

  return {language, dateFormatter, datefnsLocale};
};
export default useLanguage;
